<template>
  <v-container fluid>
    <v-row dense>    
      <v-col cols="12" sm="6" md="4" lg="2">
        <v-text-field v-model="offerta.codice"  class="mt-5" label="Codice" outlined dense :readonly="readOnly"></v-text-field>
      </v-col>
    </v-row>
    <v-row dense>    
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field v-model="offerta.descrizione" label="Descrizione" placeholder="Descrizione" outlined dense :readonly="readOnly"></v-text-field>
      </v-col>
    </v-row>
    <v-row dense>    
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field v-model="offerta.descrizioneScontrino"  label="Descrizione Scontrino" placeholder="Descrizione scontrino" outlined dense :readonly="readOnly"></v-text-field>
      </v-col>
    </v-row>
    <v-row dense>    
      <v-col cols="12" sm="6" md="4" lg="2">
        <v-select v-model="offerta.tipoOfferta" :items="tipiOfferta" label="Tipo Offerta" outlined item-value="codice" item-text="descrizione" dense  :disabled="readOnly" @change="changeTipoOfferta"></v-select>  
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="1"></v-col>
      <v-col cols="12" sm="6" md="4" lg="1" > 
        <v-text-field v-model="offerta.quantitaMinima" label="Quantità minima" outlined dense :readonly="readOnly" reverse :rules="[rules.numeropositivo]"></v-text-field>
      </v-col>            
    </v-row>
    <!-- <template v-if="offerta.tipoOfferta === 'categoria'"> -->
    <v-row dense>
      <v-col cols="12" sm="6" md="1" > 
        <v-text-field v-model="offerta.scontoPercentuale" suffix="%" label="Sconto %" outlined dense :readonly="readOnly" reverse :rules="[rules.numero]"></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="1" > 
        <v-text-field v-model="offerta.scontoEuro" suffix="€" label="Sconto €" outlined dense :readonly="readOnly" reverse :rules="[rules.numero]"></v-text-field>
      </v-col>
      <v-col cols="12" v-if="offerta.tipoOfferta === 'prodotto'">
        <span class="font-weight-medium primary--text">Gli sconti di default vengono applicati se non specificati per il singolo prodotto</span>
      </v-col>
    </v-row>
    <!-- </template>    --> 
    <v-row dense>
      <v-col md="2">
        <v-switch v-model="offerta.attiva" class="ml-5" dense inset label="Attiva"></v-switch>
      </v-col>
      <v-col md="2">
        <v-switch v-model="offerta.soloFidelity" dense inset label="Solo con Fidelity"></v-switch>
      </v-col>
    </v-row>
    <v-row dense>    
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field v-model="offerta.vincolaNota" label="Vincola nota fissa" placeholder="Nota" outlined dense :readonly="readOnly" hide-details></v-text-field>
        <small>L'offerta viene applicata solo se nello scontrino è presente un prodotto particolare</small> 
      </v-col>
    </v-row>
    <v-row dense>    
      <v-col cols="12" sm="6" md="4" lg="4">
        <component :is="'pProdotto'"
          :item="itemCodice(offerta)"
          :suTable="true"
          :updateTrigger="updateTrigger"
          @change="componentValueChange" />
          <small>L'offerta viene applicata solo se nello scontrino è presente un prodotto particolare</small>    
      </v-col>
    </v-row>
    <v-btn v-if="!readOnly" class="mt-5" @click="salvaModifiche">Salva modifiche</v-btn>
  </v-container>
</template>

<script>
  import _ from 'lodash'
  import { validazioni } from '@/mixins/validazioni.js'
  import pProdotto from './prodotto'

  export default {
    components: {
      pProdotto
    },
    props: {
      dati: Object,
      readOnly: { type: Boolean, default: false }
    },
    mixins: [
      validazioni
    ],    
    data: () => ({
      tipiOfferta: [],
      offerta: {},
      prodotto: null,
      updateTrigger: 1
    }),
    async created() {
      this.tipiOfferta = [{ codice: 'categoria', descrizione: 'Categoria' }, { codice: 'prodotto', descrizione: 'Prodotto' }]    
    },    
    async mounted() {
      this.offerta = this.dati
      await this.$nextTick()
      // setTimeout(() => {
        this.updateTrigger++
      // }, 200)
    },
    computed: {
    },
    methods: {
      salvaModifiche() {
        this.$emit('salva', this.dati)
      },
      changeTipoOfferta() {
        if (this.offerta.tipoOfferta === 'prodotto') {
          this.offerta.valori = []
          this.offerta.campoVerifica = null
        } else {
          this.offerta.articoli = []
        }
      },
      itemCodice(item, onlyValue) {
        if (onlyValue) {
          return _.get(item, 'vincolaProdotto.codice', '')
        }
        return {
          "model": "prodotto.codice",
          "valueField": "prodotto.codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "prodotto.descrizione",
          value: _.get(item, 'vincolaProdotto.codice', '')  
        }
      },
      async componentValueChange(data) {
        const { value, index, item } = data
        if (item) {
          this.offerta.vincolaProdotto = {
            codice: item.id,
            descrizione: item.descrizione
          }
        } else {
          this.offerta.vincolaProdotto = null
        }
      }   
    }
  }
</script>
